<label class="searchbox" [class.dirty]="!!searchInput.value">
  <!-- //Enter P/N or Part description -->
  <input
    #searchInput
    placeholder="{{ 'searchbox.partNumberPlaceholder' | cxTranslate }}"
    onfocus="this.placeholder = ''"
    onblur="this.placeholder = 'Part number/description'"
    (clickOutside)="close($event)"
    (focus)="open()"
    (input)="search(searchInput.value)"
    (keydown.escape)="close($event)"
    (keydown.enter)="
      close($event, true);
      launchSearchResult($event, searchInput.value, true);
      searchInput.blur()
    "
    (keydown.arrowup)="focusPreviousChild($event)"
    (keydown.arrowdown)="focusNextChild($event)"
    class="searchfiled"
  />
  <cx-icon
    *ngIf="searchQuery?.length > 0"
    [type]="iconTypes.RESET"
    aria-label="reset"
    (mousedown)="clear(searchInput)"
    (keydown.enter)="clear(searchInput)"
    class="reset"
    tabindex="0"
  ></cx-icon>
  <cx-icon
    *ngIf="searchQuery?.length == 0"
    [type]="iconTypes.SEARCH"
    aria-label="search"
    class="search"
    (mousedown)="avoidReopen($event)"
    (keydown.enter)="avoidReopen($event)"
    tabindex="0"
  ></cx-icon>
</label>
<div
  *ngIf="results$ | async as result"
  class="results ieedge-width"
  (click)="close($event, true)"
  #searchSuggestionsBox
>
  <div
    class="suggestions"
    (focus)="open()"
    (blur)="close($event)"
    *ngIf="result.products && searchQuery.length >= minSearchLength"
  >
    <!-- <a*ngFor="let suggestion of result.suggestions"
    [innerHTML]="suggestion | cxHighlight: searchInput.value"
    [routerLink]="
      {
        cxRoute: 'search',
        params: { query: suggestion }
      } | cxUrl"
    (keydown.arrowup)="focusPreviousChild($event)"
    (keydown.arrowdown)="focusNextChild($event)"
    (keydown.enter)="close($event, true)"
    (keydown.escape)="close($event, true)"
    (blur)="close($event)"
  >
  </a> -->
    <div class="col-auto suggested-div">
      <p class="suggested">{{ 'searchbox.suggestedPara' | cxTranslate }}</p>
      <h4 class="suggested-msg">
        {{ 'searchbox.productHeader' | cxTranslate }} "{{ searchInput.value }}"
      </h4>
    </div>
  </div>
  <div
    class="products"
    *ngIf="result.products && searchQuery.length >= minSearchLength"
    (focus)="open()"
    (blur)="close($event)"
  >
    <ng-container *ngFor="let product of result.products">
      <a
        (click)="searchInput.value = ''; setQuantity(product)"
        [routerLink]="
          {
            cxRoute: 'product',
            params: product
          } | cxUrl
        "
        [class.has-media]="config.displayProductImages"
        (keydown.arrowup)="focusPreviousChild($event)"
        (keydown.arrowdown)="focusNextChild($event)"
        (keydown.enter)="close($event, true)"
        (keydown.escape)="close($event, true)"
        (blur)="close($event)"
      >
        <div *ngIf="loggedIn">
          <div class="row">
            <div class="col-auto">
              <cx-media
                class="searchTumbnail"
                *ngIf="config.displayProductImages"
                [container]="product.images?.PRIMARY"
                [alt]="product.summary"
              ></cx-media>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto">
                  <p
                    class="name font-wet"
                    matTooltipClass="vs-tooltip"
                    [matTooltip]="product.code"
                  >
                    {{ product.code }}
                  </p>
                  <h4
                    class="name font-wet"
                    matTooltipClass="vs-tooltip"
                    [matTooltip]="product.name"
                  >
                    {{ product.name }}
                  </h4>
                </div>
                ​
                <div class="col-auto">
                  <div
                    *ngIf="
                      !product.hidePrice &&
                      product.price &&
                      product.price.value !== null &&
                      product.price.value !== undefined &&
                      !product.obsoleteProductFlag
                    "
                    class="list-price"
                  >
                    <p>{{ 'searchbox.listPrice' | cxTranslate }}</p>
                    <br />
                    {{ currency }}
                    <span>{{ product.price?.formattedValue }}</span>
                  </div>
                  <!-- CHECKPRICE CUSTOMIZATION 1-------------------- START -->
                  <div
                    *ngIf="
                      !product.hidePrice &&
                      checkPriceProduct[product.code] !== undefined &&
                      checkPriceProduct[product.code].display &&
                      checkPriceProduct[product.code].status === 'BUY' &&
                      !product.obsoleteProductFlag
                    "
                    class="list-price"
                  >
                    <p>{{ 'searchbox.listPrice' | cxTranslate }}</p>
                    <br />
                    {{ currency }}
                    <span>{{
                      checkPriceProduct[product.code].price?.formattedValue
                    }}</span>
                  </div>
                  <!-- CHECKPRICE CUSTOMIZATION 1-------------------- END -->
                  <div></div>
                  <div
                    class="text-warning"
                    *ngIf="product.obsoleteProductFlag == true"
                  >
                    <span class="material-icons">warning </span
                    >{{ 'searchbox.obsoletePart' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto text-right">
              <button
                *ngIf="
                  !product.hidePrice &&
                  product?.price?.value > 0 &&
                  !product.obsoleteProductFlag &&
                  (userRoles.buyer || userRoles.superUser) &&
                  product?.sellabilityFlag
                "
                (click)="
                  searchInput.value = '';
                  openCRDdialog(product, 'buy');
                  $event.preventDefault();
                  $event.stopPropagation()
                "
                class="vs-primary-btn small-size"
              >
                <span class="material-icons"> add_shopping_cart </span>
                {{ 'searchbox.buyBtn' | cxTranslate }}
              </button>
              <!-- CHECKPRICE CUSTOMIZATION 2-------------------- START -->

              <button
                *ngIf="
                  product.hidePrice ||
                  (!product?.price?.value === undefined &&
                    !product.obsoleteProductFlag) ||
                  (product.price === undefined &&
                    !product.obsoleteProductFlag &&
                    checkPriceProduct[product.code] === undefined &&
                    !(
                      product.obsoleteProductFlag &&
                      product.replacementProductUrl
                    ) &&
                    (product.sellabilityFlag || product.quotabilityFlag))
                "
                class="vs-tertiary-btn check-price-align"
                (click)="close($event, true); checkPrice(product)"
              >
                {{ 'searchbox.checkPriceBtn' | cxTranslate }}
              </button>

              <button
                *ngIf="
                  (!product.hidePrice &&
                    !product?.price?.value === undefined &&
                    !product.obsoleteProductFlag) ||
                  (product.price === undefined &&
                    !product.obsoleteProductFlag &&
                    checkPriceProduct[product.code] !== undefined &&
                    checkPriceProduct[product.code].price !== undefined &&
                    checkPriceProduct[product.code].price.value > 0 &&
                    checkPriceProduct[product.code].status === 'BUY' &&
                    product?.sellabilityFlag)
                "
                (click)="
                  searchInput.value = '';
                  openCRDdialog(product, 'buy');
                  $event.preventDefault();
                  $event.stopPropagation()
                "
                class="vs-primary-btn small-size"
              >
                <span class="material-icons"> add_shopping_cart </span>
                {{ 'searchbox.buyBtn' | cxTranslate }}
              </button>

              <button
                *ngIf="
                  (!product.hidePrice &&
                    product?.quotabilityFlag &&
                    !product?.price?.value === undefined &&
                    !product.obsoleteProductFlag) ||
                  (product?.price?.value === undefined &&
                    !product.obsoleteProductFlag &&
                    checkPriceProduct[product.code] === undefined &&
                    !product?.sellabilityFlag)
                "
                class="vs-tertiary-btn"
                (click)="
                  searchInput.value = '';
                  $event.stopPropagation();
                  $event.preventDefault();
                  openCRDdialog(product, 'quote')
                "
                [disabled]="displayQuoteSpinner"
              >
                <div class="availability-spinner cx-spinner" *ngIf="displayQuoteSpinner">
                  <cx-spinner></cx-spinner>
                </div>
                <span class="material-icons"> receipt </span>
                {{ 'searchbox.getAQuote' | cxTranslate }}
              </button>

              <button
                *ngIf="
                  !product.hidePrice &&
                  product?.quotabilityFlag &&
                  checkPriceProduct[product.code] !== undefined &&
                  (checkPriceProduct[product.code].status === 'QUOTE' ||
                    checkPriceProduct[product.code].price.value === 0)
                "
                class="vs-tertiary-btn"
                (click)="
                  searchInput.value = '';
                  $event.stopPropagation();
                  $event.preventDefault();
                  openCRDdialog(product, 'quote')
                "
                [disabled]="displayQuoteSpinner"
              >
                <div class="availability-spinner cx-spinner" *ngIf="displayQuoteSpinner">
                  <cx-spinner></cx-spinner>
                </div>
                <span class="material-icons"> receipt </span>
                {{ 'searchbox.getAQuote' | cxTranslate }}
              </button>

              <!-- CHECKPRICE CUSTOMIZATION 2-------------------- END -->

              <button
                class="vs-tertiary-btn upward"
                *ngIf="
                  !product.hidePrice &&
                  product.obsoleteProductFlag &&
                  product.replacementProductUrl
                "
                (click)="
                  searchInput.value = '';
                  navigateToReplacementProduct($event, product);
                  $event.stopPropagation();
                  $event.preventDefault()
                "
              >
                <span class="material-icons"> swap_horiz </span>
                {{ 'searchbox.viewReplacement' | cxTranslate }}
              </button>
              <button
                *ngIf="
                  product?.quotabilityFlag &&
                  !product.hidePrice &&
                  !(
                    product?.price?.value > 0 &&
                    !product.obsoleteProductFlag &&
                    product?.sellabilityFlag
                  ) &&
                  product?.price &&
                  product?.price?.value !== undefined &&
                  product?.price?.value !== null &&
                  !(
                    product.obsoleteProductFlag && product.replacementProductUrl
                  )
                "
                class="vs-tertiary-btn"
                (click)="
                  searchInput.value = '';
                  $event.stopPropagation();
                  $event.preventDefault();
                  openCRDdialog(product, 'quote')
                "
                [disabled]="displayQuoteSpinner"
              >
                <div class="availability-spinner cx-spinner" *ngIf="displayQuoteSpinner">
                  <cx-spinner></cx-spinner>
                </div>
                <span class="material-icons"> receipt </span>
                {{ 'searchbox.getAQuote' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="row col mx-auto">
            <div
              *ngIf="product.newLegacyMaterial"
              class="text-warning legacy-text"
            >
              <span class="material-icons">warning </span>
              {{ 'searchbox.replacementPartFor' | cxTranslate }}
              {{ product?.newLegacyMaterial }}
            </div>
          </div>
        </div>
        <div *ngIf="!loggedIn">
          <div class="row">
            <div class="col-auto">
              <cx-media
                class="searchTumbnail"
                *ngIf="config.displayProductImages"
                [container]="product.images?.PRIMARY"
                [alt]="product.summary"
              ></cx-media>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto">
                  <p class="name">{{ product.code }}</p>
                  <h4
                    class="name"
                    matTooltipClass="vs-tooltip"
                    [matTooltip]="product.name"
                  >
                    {{ product.name }}
                  </h4>
                </div>
                <div class="col-auto">
                  <div *ngIf="product.obsoleteProductFlag" class="text-warning">
                    <span class="material-icons">warning </span
                    >{{ 'searchbox.obsoletePart' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            ​
            <div class="col-auto text-right">
              <button
                class="vs-tertiary-btn"
                *ngIf="
                  product.obsoleteProductFlag && product.replacementProductUrl
                "
                (click)="
                  searchInput.value = '';
                  navigateToReplacementProduct($event, product);
                  $event.stopPropagation();
                  $event.preventDefault()
                "
              >
                <span class="material-icons"> swap_horiz </span>
                {{ 'searchbox.viewReplacement' | cxTranslate }}
              </button>
              <!-- <button
                *ngIf="
                  !product.hidePrice &&
                  (!product.obsoleteProductFlag ||
                    (product.obsoleteProductFlag &&
                      !product.replacementProductUrl)) &&
                  !product?.sellabilityFlag
                "
                (click)="
                  searchInput.value = '';
                  $event.preventDefault();
                  $event.stopPropagation();
                  getQuote(product)
                "
                class="vs-tertiary-btn"
              >
                <span class="material-icons"> receipt </span>
                {{ 'searchbox.getAQuote' | cxTranslate }}
              </button> -->
            </div>
          </div>
          <div class="row col mx-auto">
            <div
              *ngIf="product.newLegacyMaterial"
              class="text-warning legacy-text"
            >
              <span class="material-icons">warning </span
              >{{ 'searchbox.replacementPartFor' | cxTranslate }}
              {{ product?.newLegacyMaterial }}
            </div>
          </div>
        </div>
      </a>
    </ng-container>
    <div class="ter-btn-holder">
      <button
        class="vs-tertiary-btn anchor"
        [routerLink]="'search/' + searchQuery"
        (click)="launchSearchResult($event, searchQuery, true)"
      >
        {{ 'searchbox.viewAllResult' | cxTranslate }}
      </button>
    </div>
  </div>
</div>
